// exportHtml — stub temporário (Sprint 1.2 → 2).
//
// Mantém apenas o que builder precisa pra import/export JSON do schema.
// `downloadHtml` está stubado: o gerador real vem no Sprint 3 (runtime
// Preact + @nanoapp/exporter), e o builder vai consumir tudo via
// `utils/exporter.ts` (a ser criado no Sprint 3) — esse arquivo deixa
// apenas a superfície mínima usada por Dashboard (importar JSON) e
// BuilderToolbar (exportar JSON, alertar pra exportar HTML mais tarde).
import type { FormDocument } from '@nanoapp/types';

export function downloadJson(form: FormDocument): void {
  const blob = new Blob([JSON.stringify(form, null, 2)], { type: 'application/json;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${(form.settings.title || 'formulario').toLowerCase().replace(/\s+/g, '-')}.formcraft.json`;
  a.click();
  URL.revokeObjectURL(url);
}

export function readFormJson(file: File): Promise<FormDocument> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const doc = JSON.parse(e.target?.result as string) as FormDocument;
        if (!doc.id || !doc.settings || !Array.isArray(doc.fields)) {
          reject(new Error('Arquivo inválido: não parece ser um formulário NanoApp.'));
          return;
        }
        resolve(doc);
      } catch {
        reject(new Error('Não foi possível ler o arquivo. Verifique se é um JSON válido.'));
      }
    };
    reader.onerror = () => reject(new Error('Erro ao ler o arquivo.'));
    reader.readAsText(file);
  });
}

export function downloadHtml(_form: FormDocument): void {
  // Sprint 3 vai habilitar geração de HTML standalone (runtime Preact embutido).
  alert('Exportar HTML será habilitado no Sprint 3 (runtime Preact + bundle standalone).');
}
